import script from "./TopNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNotice.vue?vue&type=script&setup=true&lang=js"

import "./TopNotice.vue?vue&type=style&index=0&id=67b181c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b181c1"]])

export default __exports__